import { Data, RouterStateSnapshot } from '@angular/router';

import { RouterStateSerializer } from '@ngrx/router-store';

import { MasterDetailData, ModuleRouterState } from '../types/module-router.types';

export class ModuleRouterSerializer implements RouterStateSerializer<ModuleRouterState> {
  serialize(routerState: RouterStateSnapshot): ModuleRouterState {
    let route = routerState.root;
    let companyId: number | null = null;
    let module: string | null = null;
    let submodule: string | null = null;
    let detailId: string | null = null;
    let action: string | null = null;
    let data: Data = {};
    let masterDetailData: MasterDetailData | null = null;

    while (route.firstChild) {
      route = route.firstChild;
      const currentData = route.data ?? {};

      if (Object.hasOwn(route.params, 'companyId')) {
        companyId = +route.params['companyId'];
      }

      if (Object.hasOwn(route.params, 'module')) {
        module = route.params['module'];
      }

      if (Object.hasOwn(route.params, 'submodule')) {
        submodule = route.params['submodule'];
      }

      if (!submodule && Object.hasOwn(currentData, 'submodule')) {
        submodule = currentData['submodule'];
      }

      if (Object.hasOwn(route.params, 'detailId')) {
        detailId = route.params['detailId'];
      }

      if (Object.hasOwn(route.params, 'action')) {
        action = route.params['action'];
      }

      if (Object.hasOwn(currentData, 'parentRoute')
        && Object.hasOwn(currentData, 'masterRoute')
        && Object.hasOwn(currentData, 'childRoute')) {
        masterDetailData = {
          parentRoute: currentData['parentRoute'],
          masterRoute: currentData['masterRoute'],
          childRoute: currentData['childRoute'],
        };
      }

      data = { ...data, ...currentData };
    }

    return {
      url: routerState.url,
      queryParams: route.root.queryParams,
      companyId,
      module,
      submodule,
      detailId,
      action,
      data,

      // Simulate page type from old router store
      pageType: calculatePageType(detailId),
      // Simulate evidence from old router store
      evidence: route.root.queryParams['evidence'] ?? submodule,
      // Simulate master/detail data from old router store
      masterDetailData,
    };
  }
}

/**
 * Simulate page type from old router store
 * 0 - other
 * 3 - detail
 * 4 - create
 *
 * @see KrosRouterStorePageType (libs/shared/router-store/src/lib/kros-router-store.types.ts)
 */
function calculatePageType(detailId: unknown): number {
  if (!detailId) {
    return 0;
  }

  if (detailId === 'create') {
    return 4;
  }

  return 3;
}
